import { CURRENCY_TO_COUNTRY_NAME } from "../constants/quoter-history.constants";
import type { QuoterQuoteData } from "../types/quoter.types";
import type { CreateShippingQuoteDto } from "../types/shipping-quotes-api.types";

function getCountryNameForCurrency(currencyCode: string): string {
  return CURRENCY_TO_COUNTRY_NAME[currencyCode] ?? currencyCode;
}

function toNumber(value: unknown): number {
  const n = typeof value === "number" ? value : Number(value);
  return Number.isFinite(n) ? n : 0;
}

export function buildShippingQuotePayload(
  quote: QuoterQuoteData
): CreateShippingQuoteDto {
  const amount_to_send = toNumber(quote.breakdown.amount_sent);
  const amount_to_receive = toNumber(quote.breakdown.amount_received);
  const commission = toNumber(quote.fees.percentage_fee);
  const exchange_rate = toNumber(quote.rate);

  const payload: CreateShippingQuoteDto = {
    origin_currency: quote.currency.from,
    destination_currency: quote.currency.to,
    amount_to_send,
    amount_to_receive,
    commission,
    exchange_rate,
    quote_source: "internal",
    country_origin: getCountryNameForCurrency(quote.currency.from),
    country_destination: getCountryNameForCurrency(quote.currency.to),
    valid_until: new Date(Date.now() + 60 * 60 * 1000).toISOString(), // +1h ISO 8601
    metadata: { referrer: "web" },
  };

  return payload;
}
